<div class="container-fluid" style="margin-bottom: 20px; padding-bottom: 20px;">
  <p-panel>
    <ng-template pTemplate="header">
      <div class="row" style="padding: 5px !important; width:100% !important;">
        <div class="col-auto d-flex align-items-center" style="padding-right: 0 !important;">
          <div class="d-flex align-items-center">
            <h3 style="margin-bottom: 0 !important;">
              <span style="margin-left: 15px;"><fa-icon [icon]="['fas', 'books']"> </fa-icon> Enterprise Documents</span>
            </h3>
          </div>
        </div>
        <div class="col pull-right">
          <app-eca-ghost-btn class="card-action-icon float-right" btnIcon="question-circle" btnType="warning" (btnClicked)="openCompanyDocumentsHelp()">
          </app-eca-ghost-btn>
        </div>
      </div>
    </ng-template>
    <ng-template pTemplate="content">
      <div class="container-fluid " style="padding-left: 0; padding-right: 0; padding-top:20px;">
        <div *ngIf="companyDocumentsLoading" class="text-center">
          <fa-duotone-icon [icon]="['fad', 'spinner']" [spin]="true" [pulse]="true" size="4x" primaryColor="darkgreen" secondaryColor="green"></fa-duotone-icon>
        </div>
        <div *ngIf="!companyDocumentsLoading">
          <app-documents-list [showTableCaption]="true" [showHeaderText]="true" [showCount]="true"
                              [documents]="companyDocumentSummaries"
                              [addDocumentButtonText]="'Add'"
                              [allowedOperations]="loggedInUser?.documentOperations"
                              [headerText]="'Enterprise Documents'"
                              (addDocument)="addCompanyDocument()"
                              (editDocument)="editCompanyDocument($event)"
                              (deleteDocument)="deleteCompanyDocumentClick($event)"
                              (downloadDocument)="downloadCompanyDocument($event)"
                              (openDocument)="openCompanyDocument($event)"
                              (viewDocument)="viewCompanyDocument($event)"
                              (refreshDocumentsRequested)="refreshDocuments($event)"></app-documents-list>
        </div>
      </div>
    </ng-template>
  </p-panel>
</div>
